import { Component } from '@angular/core';
import { BusinesscaseStatusDashboardService } from './businesscase-status-dashboard.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-businesscase-status-dashboard',
  templateUrl: './businesscase-status-dashboard.component.html',
  styleUrl: './businesscase-status-dashboard.component.scss'
})
export class BusinesscaseStatusDashboardComponent {
  summary: any = {
    total_records: 0,
    locked_count: 0,
    unlocked_count: 0,
    not_in_businesscase_count: 0
  };

  statusOptions = [
    { label: 'Locked', value: 'locked' },
    { label: 'Unlocked', value: 'unlocked' },
    { label: 'Not in Business Case', value: 'not_in_businesscase' }
  ];

  selectedStatus: string = 'locked'; // Default
  searchText: string = '';
  originalData: any[] = [];
  filteredData: any[] = [];
  loading = false;
  searchSubject = new Subject<string>();
  email: any; // Replace with actual email logic

  constructor(private businessService: BusinesscaseStatusDashboardService) { }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.searchSubject.pipe(debounceTime(300)).subscribe((value) => {
      this.searchText = value;
      this.onStatusFilterChange(); // triggers API
    });
    this.fetchBusinessStatus();
  }

  fetchBusinessStatus(): void {
    this.loading = true;
    this.businessService.getBusinessStatus(this.email).subscribe({
      next: (res: any) => {
        this.summary = res.summary;

        // Default to locked_businesscases
        this.originalData = res.locked_businesscases || [];
        this.filteredData = [...this.originalData];

        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching business status:', err);
        this.loading = false;
      }
    });
  }

  // onStatusFilterChange(): void {
  //   if (!this.selectedStatus) return;

  //   const filterPayload = {
  //     user_email: this.email,
  //     // brand_name: '',
  //     // nda: ''
  //   };

  //   this.loading = true;

  //   this.businessService.filterBusinessStatus(filterPayload).subscribe({
  //     next: (res: any) => {
  //       this.summary = res.summary || this.summary;

  //       switch (this.selectedStatus) {
  //         case 'locked':
  //           this.originalData = res.locked_businesscases || [];
  //           break;
  //         case 'unlocked':
  //           this.originalData = res.unlocked_businesscases || [];
  //           break;
  //         case 'not_in_businesscase':
  //           this.originalData = res.not_in_businesscase || [];
  //           break;
  //       }

  //       this.applySearchFilter();
  //       this.loading = false;
  //     },
  //     error: (err) => {
  //       console.error('Filter API error:', err);
  //       this.loading = false;
  //     }
  //   });
  // }

  // applySearchFilter(): void {
  //   const keyword = this.searchText.toLowerCase();

  //   this.filteredData = this.originalData.filter(item => {
  //     return (
  //       item.brand_name?.toLowerCase().includes(keyword) ||
  //       item.nda?.toString().includes(keyword)
  //     );
  //   });
  // }

  onStatusFilterChange(): void {
    if (!this.selectedStatus) return;

    const filterPayload = {
      user_email: this.email,
      search_value: this.searchText?.trim() || ''
    };

    this.loading = true;

    this.businessService.filterBusinessStatus(filterPayload).subscribe({
      next: (res: any) => {
        this.summary = res.summary || this.summary;

        switch (this.selectedStatus) {
          case 'locked':
            this.originalData = res.locked_businesscases || [];
            break;
          case 'unlocked':
            this.originalData = res.unlocked_businesscases || [];
            break;
          case 'not_in_businesscase':
            this.originalData = res.not_in_businesscase || [];
            break;
        }

        this.filteredData = this.originalData;
        this.loading = false;
      },
      error: (err) => {
        console.error('Filter API error:', err);
        this.loading = false;
      }
    });
  }

  onSearchInputChange(value: string): void {
    this.loading = true;  // show loader immediately
    this.searchSubject.next(value);
  }

}
